"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _mutationTypes = require("../mutation-types");
var _dashboard = _interopRequireDefault(require("@/services/dashboard.service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  listConsumption: {},
  listLastResults: {},
  detailErroSelectedDashboard: null,
  numberOfItensByType: {
    requestCreatedHive: null,
    responseSentClient: null,
    cacheResponseClient: null,
    requestErrorProvider: null,
    requestCreatedProvider: null,
    responseErrorSentClient: null,
    requestReceivedProvider: null,
    responseNotReceivedClient: null
  }
};
var mutations = _defineProperty(_defineProperty(_defineProperty({}, _mutationTypes.SET_LIST_CONSUMPTION, function (mutationState, payload) {
  mutationState.listConsumption = payload;
}), _mutationTypes.SET_LIST_LAST_RESULTS, function (mutationState, payload) {
  mutationState.listLastResults = payload;
}), _mutationTypes.SET_DETAIL_OPEN_DASHBOARD, function (mutationState, payload) {
  mutationState.detailErroSelectedDashboard = payload;
});
var getters = {
  listConsumption: function listConsumption(state) {
    return state.listConsumption;
  },
  listLastResults: function listLastResults(state) {
    return state.listLastResults;
  },
  detailErroSelectedDashboard: function detailErroSelectedDashboard(state) {
    return state.detailErroSelectedDashboard;
  }
};
var actions = {
  fetchDashboardDataConsolidatedCreatedHive: function () {
    var _fetchDashboardDataConsolidatedCreatedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, params) {
      var commit, _yield$DashboardServi, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            _context.p = 1;
            _context.n = 2;
            return _dashboard.default.fetchDataConsolidatedCreatedHive(params);
          case 2:
            _yield$DashboardServi = _context.v;
            data = _yield$DashboardServi.data;
            return _context.a(2, data.data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    function fetchDashboardDataConsolidatedCreatedHive(_x, _x2) {
      return _fetchDashboardDataConsolidatedCreatedHive.apply(this, arguments);
    }
    return fetchDashboardDataConsolidatedCreatedHive;
  }(),
  fetchDashboardDataConsolidatedCreatedProvider: function () {
    var _fetchDashboardDataConsolidatedCreatedProvider = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref2, params) {
      var commit, _yield$DashboardServi2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref2.commit;
            _context2.p = 1;
            _context2.n = 2;
            return _dashboard.default.fetchDataConsolidatedCreatedProvider(params);
          case 2:
            _yield$DashboardServi2 = _context2.v;
            data = _yield$DashboardServi2.data;
            return _context2.a(2, data.data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    function fetchDashboardDataConsolidatedCreatedProvider(_x3, _x4) {
      return _fetchDashboardDataConsolidatedCreatedProvider.apply(this, arguments);
    }
    return fetchDashboardDataConsolidatedCreatedProvider;
  }(),
  fetchDashboardDataConsolidatedReceivedHive: function () {
    var _fetchDashboardDataConsolidatedReceivedHive = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref3, params) {
      var commit, _yield$DashboardServi3, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref3.commit;
            _context3.p = 1;
            _context3.n = 2;
            return _dashboard.default.fetchDataConsolidatedReceivedHive(params);
          case 2:
            _yield$DashboardServi3 = _context3.v;
            data = _yield$DashboardServi3.data;
            return _context3.a(2, data.data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    function fetchDashboardDataConsolidatedReceivedHive(_x5, _x6) {
      return _fetchDashboardDataConsolidatedReceivedHive.apply(this, arguments);
    }
    return fetchDashboardDataConsolidatedReceivedHive;
  }(),
  fetchDashboardDataConsolidatedSendClient: function () {
    var _fetchDashboardDataConsolidatedSendClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref4, params) {
      var commit, _yield$DashboardServi4, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref4.commit;
            _context4.p = 1;
            _context4.n = 2;
            return _dashboard.default.fetchDataConsolidatedSendClient(params);
          case 2:
            _yield$DashboardServi4 = _context4.v;
            data = _yield$DashboardServi4.data;
            return _context4.a(2, data.data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    function fetchDashboardDataConsolidatedSendClient(_x7, _x8) {
      return _fetchDashboardDataConsolidatedSendClient.apply(this, arguments);
    }
    return fetchDashboardDataConsolidatedSendClient;
  }(),
  fetchConsumption: function () {
    var _fetchConsumption = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref5, _ref6) {
      var commit, days, params, _yield$DashboardServi5, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref5.commit;
            days = _ref6.days, params = _ref6.params;
            _context5.p = 1;
            _context5.n = 2;
            return _dashboard.default.fetchConsumption(days, params);
          case 2:
            _yield$DashboardServi5 = _context5.v;
            data = _yield$DashboardServi5.data;
            commit(_mutationTypes.SET_LIST_CONSUMPTION, data);
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    function fetchConsumption(_x9, _x0) {
      return _fetchConsumption.apply(this, arguments);
    }
    return fetchConsumption;
  }(),
  fetchLastResults: function () {
    var _fetchLastResults = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref7, _ref8) {
      var commit, time, page, perPage, _yield$DashboardServi6, data, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref7.commit;
            time = _ref8.time, page = _ref8.page, perPage = _ref8.perPage;
            _context6.p = 1;
            _context6.n = 2;
            return _dashboard.default.fetchLastResults(time, page, perPage);
          case 2:
            _yield$DashboardServi6 = _context6.v;
            data = _yield$DashboardServi6.data;
            commit(_mutationTypes.SET_LIST_LAST_RESULTS, data);
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    function fetchLastResults(_x1, _x10) {
      return _fetchLastResults.apply(this, arguments);
    }
    return fetchLastResults;
  }(),
  fetchDetailDashboard: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref9, payload) {
      var commit, _yield$DashboardServi7, data, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref9.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _dashboard.default.fetchConsumptionDetail(payload);
          case 2:
            _yield$DashboardServi7 = _context7.v;
            data = _yield$DashboardServi7.data;
            commit(_mutationTypes.SET_DETAIL_OPEN_DASHBOARD, data);
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref0.apply(this, arguments);
    };
  }()),
  setDetailDashboard: (0, _underLoading.underLoadingFunction)(function (_ref1, payload) {
    var commit = _ref1.commit;
    commit(_mutationTypes.SET_DETAIL_OPEN_DASHBOARD, payload);
  }),
  fetchDetailServiceActiveDashboard: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref10, payload) {
      var commit, _yield$DashboardServi8, data, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref10.commit;
            _context8.p = 1;
            _context8.n = 2;
            return _dashboard.default.fetchDetailServiceActiveDashboard(payload);
          case 2:
            _yield$DashboardServi8 = _context8.v;
            data = _yield$DashboardServi8.data;
            return _context8.a(2, data);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref11.apply(this, arguments);
    };
  }()),
  fetchDetailServiceDashboard: function () {
    var _fetchDetailServiceDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref12, payload) {
      var commit, _yield$DashboardServi9, data, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref12.commit;
            _context9.p = 1;
            _context9.n = 2;
            return _dashboard.default.fetchDetailServiceDashboard(payload);
          case 2:
            _yield$DashboardServi9 = _context9.v;
            data = _yield$DashboardServi9.data;
            return _context9.a(2, data);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    function fetchDetailServiceDashboard(_x15, _x16) {
      return _fetchDetailServiceDashboard.apply(this, arguments);
    }
    return fetchDetailServiceDashboard;
  }(),
  fetchLatestServiceCallDashboard: function () {
    var _fetchLatestServiceCallDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref13, payload) {
      var commit, _yield$DashboardServi0, data, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref13.commit;
            _context0.p = 1;
            _context0.n = 2;
            return _dashboard.default.fetchLatestServiceCallDashboard(payload);
          case 2:
            _yield$DashboardServi0 = _context0.v;
            data = _yield$DashboardServi0.data;
            return _context0.a(2, data);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    function fetchLatestServiceCallDashboard(_x17, _x18) {
      return _fetchLatestServiceCallDashboard.apply(this, arguments);
    }
    return fetchLatestServiceCallDashboard;
  }(),
  fetchLatestServiceCallChartDashboard: function () {
    var _fetchLatestServiceCallChartDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(_ref14, payload) {
      var commit, _yield$DashboardServi1, data, _t1;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            commit = _ref14.commit;
            _context1.p = 1;
            _context1.n = 2;
            return _dashboard.default.fetchLatestServiceCallChartDashboard(payload);
          case 2:
            _yield$DashboardServi1 = _context1.v;
            data = _yield$DashboardServi1.data;
            return _context1.a(2, data);
          case 3:
            _context1.p = 3;
            _t1 = _context1.v;
            _helpers.errorResponseHelper.display(_t1);
            return _context1.a(2, false);
        }
      }, _callee1, null, [[1, 3]]);
    }));
    function fetchLatestServiceCallChartDashboard(_x19, _x20) {
      return _fetchLatestServiceCallChartDashboard.apply(this, arguments);
    }
    return fetchLatestServiceCallChartDashboard;
  }(),
  fetchLatestServiceCallTotalDashboard: function () {
    var _fetchLatestServiceCallTotalDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref15, payload) {
      var commit, _yield$DashboardServi10, data, _t10;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            commit = _ref15.commit;
            _context10.p = 1;
            _context10.n = 2;
            return _dashboard.default.fetchLatestServiceCallTotalDashboard(payload);
          case 2:
            _yield$DashboardServi10 = _context10.v;
            data = _yield$DashboardServi10.data;
            return _context10.a(2, data);
          case 3:
            _context10.p = 3;
            _t10 = _context10.v;
            _helpers.errorResponseHelper.display(_t10);
            return _context10.a(2, false);
        }
      }, _callee10, null, [[1, 3]]);
    }));
    function fetchLatestServiceCallTotalDashboard(_x21, _x22) {
      return _fetchLatestServiceCallTotalDashboard.apply(this, arguments);
    }
    return fetchLatestServiceCallTotalDashboard;
  }(),
  fetchLatestServiceCallTotalMonetizablesDashboard: function () {
    var _fetchLatestServiceCallTotalMonetizablesDashboard = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_ref16, payload) {
      var commit, _yield$DashboardServi11, data, _t11;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            commit = _ref16.commit;
            _context11.p = 1;
            _context11.n = 2;
            return _dashboard.default.fetchLatestServiceCallTotalMonetizablesDashboard(payload);
          case 2:
            _yield$DashboardServi11 = _context11.v;
            data = _yield$DashboardServi11.data;
            return _context11.a(2, data);
          case 3:
            _context11.p = 3;
            _t11 = _context11.v;
            _helpers.errorResponseHelper.display(_t11);
            return _context11.a(2, false);
        }
      }, _callee11, null, [[1, 3]]);
    }));
    function fetchLatestServiceCallTotalMonetizablesDashboard(_x23, _x24) {
      return _fetchLatestServiceCallTotalMonetizablesDashboard.apply(this, arguments);
    }
    return fetchLatestServiceCallTotalMonetizablesDashboard;
  }(),
  fetchLatestServiceCallTotalErrorsDashboard: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(_ref17, payload) {
      var commit, _yield$DashboardServi12, data, _t12;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            commit = _ref17.commit;
            _context12.p = 1;
            _context12.n = 2;
            return _dashboard.default.fetchLatestServiceCallTotalErrorsDashboard(payload);
          case 2:
            _yield$DashboardServi12 = _context12.v;
            data = _yield$DashboardServi12.data;
            return _context12.a(2, data);
          case 3:
            _context12.p = 3;
            _t12 = _context12.v;
            _helpers.errorResponseHelper.display(_t12);
            return _context12.a(2, false);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    return function (_x25, _x26) {
      return _ref18.apply(this, arguments);
    };
  }()),
  fetchTimesDocumentoscopia: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(_ref19, payload) {
      var commit, _yield$DashboardServi13, data, _t13;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            commit = _ref19.commit;
            _context13.p = 1;
            _context13.n = 2;
            return _dashboard.default.fetchTimesDocumentoscopia(payload);
          case 2:
            _yield$DashboardServi13 = _context13.v;
            data = _yield$DashboardServi13.data;
            return _context13.a(2, data);
          case 3:
            _context13.p = 3;
            _t13 = _context13.v;
            _helpers.errorResponseHelper.display(_t13);
            return _context13.a(2, false);
        }
      }, _callee13, null, [[1, 3]]);
    }));
    return function (_x27, _x28) {
      return _ref20.apply(this, arguments);
    };
  }()),
  fetchListErrorsDashboard: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref22 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(_ref21, payload) {
      var commit, _yield$DashboardServi14, data, _t14;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.p = _context14.n) {
          case 0:
            commit = _ref21.commit;
            _context14.p = 1;
            _context14.n = 2;
            return _dashboard.default.fetchListErrorsDashboard(payload);
          case 2:
            _yield$DashboardServi14 = _context14.v;
            data = _yield$DashboardServi14.data;
            return _context14.a(2, data);
          case 3:
            _context14.p = 3;
            _t14 = _context14.v;
            _helpers.errorResponseHelper.display(_t14);
            return _context14.a(2, false);
        }
      }, _callee14, null, [[1, 3]]);
    }));
    return function (_x29, _x30) {
      return _ref22.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotal: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref24 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(_ref23, payload) {
      var commit, _yield$DashboardServi15, data, _t15;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.p = _context15.n) {
          case 0:
            commit = _ref23.commit;
            _context15.p = 1;
            _context15.n = 2;
            return _dashboard.default.featchLastServiceActiveCallsTotal(payload);
          case 2:
            _yield$DashboardServi15 = _context15.v;
            data = _yield$DashboardServi15.data;
            return _context15.a(2, data);
          case 3:
            _context15.p = 3;
            _t15 = _context15.v;
            _helpers.errorResponseHelper.display(_t15);
            return _context15.a(2, false);
        }
      }, _callee15, null, [[1, 3]]);
    }));
    return function (_x31, _x32) {
      return _ref24.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotalMonetizables: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref26 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(_ref25, payload) {
      var commit, _yield$DashboardServi16, data, _t16;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.p = _context16.n) {
          case 0:
            commit = _ref25.commit;
            _context16.p = 1;
            _context16.n = 2;
            return _dashboard.default.featchLastServiceActiveCallsTotalMonetizables(payload);
          case 2:
            _yield$DashboardServi16 = _context16.v;
            data = _yield$DashboardServi16.data;
            return _context16.a(2, data);
          case 3:
            _context16.p = 3;
            _t16 = _context16.v;
            _helpers.errorResponseHelper.display(_t16);
            return _context16.a(2, false);
        }
      }, _callee16, null, [[1, 3]]);
    }));
    return function (_x33, _x34) {
      return _ref26.apply(this, arguments);
    };
  }()),
  featchLastServiceActiveCallsTotalErros: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref29 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(_ref27, _ref28) {
      var commit, id, params, _yield$DashboardServi17, data, _t17;
      return _regenerator().w(function (_context17) {
        while (1) switch (_context17.p = _context17.n) {
          case 0:
            commit = _ref27.commit;
            id = _ref28.id, params = _ref28.params;
            _context17.p = 1;
            _context17.n = 2;
            return _dashboard.default.featchLastServiceActiveCallsTotalErros(id, params);
          case 2:
            _yield$DashboardServi17 = _context17.v;
            data = _yield$DashboardServi17.data;
            return _context17.a(2, data);
          case 3:
            _context17.p = 3;
            _t17 = _context17.v;
            _helpers.errorResponseHelper.display(_t17);
            return _context17.a(2, false);
        }
      }, _callee17, null, [[1, 3]]);
    }));
    return function (_x35, _x36) {
      return _ref29.apply(this, arguments);
    };
  }()),
  fetchListErrorsTransactions: function () {
    var _fetchListErrorsTransactions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(_ref30, _ref31) {
      var commit, days, params, _yield$DashboardServi18, data, _t18;
      return _regenerator().w(function (_context18) {
        while (1) switch (_context18.p = _context18.n) {
          case 0:
            commit = _ref30.commit;
            days = _ref31.days, params = _ref31.params;
            _context18.p = 1;
            _context18.n = 2;
            return _dashboard.default.fetchListErrorsTransactions(days, params);
          case 2:
            _yield$DashboardServi18 = _context18.v;
            data = _yield$DashboardServi18.data;
            return _context18.a(2, data);
          case 3:
            _context18.p = 3;
            _t18 = _context18.v;
            _helpers.errorResponseHelper.display(_t18);
            return _context18.a(2, false);
        }
      }, _callee18, null, [[1, 3]]);
    }));
    function fetchListErrorsTransactions(_x37, _x38) {
      return _fetchListErrorsTransactions.apply(this, arguments);
    }
    return fetchListErrorsTransactions;
  }(),
  fetchListErrorsReceptionist: function () {
    var _fetchListErrorsReceptionist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(_ref32, _ref33) {
      var commit, days, params, _yield$DashboardServi19, data, _t19;
      return _regenerator().w(function (_context19) {
        while (1) switch (_context19.p = _context19.n) {
          case 0:
            commit = _ref32.commit;
            days = _ref33.days, params = _ref33.params;
            _context19.p = 1;
            _context19.n = 2;
            return _dashboard.default.fetchListErrorsReceptionist(days, params);
          case 2:
            _yield$DashboardServi19 = _context19.v;
            data = _yield$DashboardServi19.data;
            return _context19.a(2, data);
          case 3:
            _context19.p = 3;
            _t19 = _context19.v;
            _helpers.errorResponseHelper.display(_t19);
            return _context19.a(2, false);
        }
      }, _callee19, null, [[1, 3]]);
    }));
    function fetchListErrorsReceptionist(_x39, _x40) {
      return _fetchListErrorsReceptionist.apply(this, arguments);
    }
    return fetchListErrorsReceptionist;
  }(),
  fetchLastTransactionsReceptionist: function () {
    var _fetchLastTransactionsReceptionist = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(_ref34, _ref35) {
      var commit, time, page, perPage, _yield$DashboardServi20, data, _t20;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.p = _context20.n) {
          case 0:
            commit = _ref34.commit;
            time = _ref35.time, page = _ref35.page, perPage = _ref35.perPage;
            _context20.p = 1;
            _context20.n = 2;
            return _dashboard.default.fetchLastTransactionsReceptionist(time, page, perPage);
          case 2:
            _yield$DashboardServi20 = _context20.v;
            data = _yield$DashboardServi20.data;
            commit(_mutationTypes.SET_LIST_LAST_RESULTS, data);
            return _context20.a(2, data);
          case 3:
            _context20.p = 3;
            _t20 = _context20.v;
            _helpers.errorResponseHelper.display(_t20);
            return _context20.a(2, false);
        }
      }, _callee20, null, [[1, 3]]);
    }));
    function fetchLastTransactionsReceptionist(_x41, _x42) {
      return _fetchLastTransactionsReceptionist.apply(this, arguments);
    }
    return fetchLastTransactionsReceptionist;
  }(),
  fetchNumberOfItensInLastDays: function () {
    var _fetchNumberOfItensInLastDays = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(_ref36, _ref37) {
      var commit, type, days, _yield$DashboardServi21, data, _t21;
      return _regenerator().w(function (_context21) {
        while (1) switch (_context21.p = _context21.n) {
          case 0:
            commit = _ref36.commit;
            type = _ref37.type, days = _ref37.days;
            _context21.p = 1;
            _context21.n = 2;
            return _dashboard.default.fetchNumberOfItensInLastDays(type, days);
          case 2:
            _yield$DashboardServi21 = _context21.v;
            data = _yield$DashboardServi21.data;
            return _context21.a(2, data);
          case 3:
            _context21.p = 3;
            _t21 = _context21.v;
            _helpers.errorResponseHelper.display(_t21);
            return _context21.a(2, false);
        }
      }, _callee21, null, [[1, 3]]);
    }));
    function fetchNumberOfItensInLastDays(_x43, _x44) {
      return _fetchNumberOfItensInLastDays.apply(this, arguments);
    }
    return fetchNumberOfItensInLastDays;
  }(),
  fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType: function () {
    var _fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(_ref38, _ref39) {
      var commit, type, days, _yield$DashboardServi22, data, _t22;
      return _regenerator().w(function (_context22) {
        while (1) switch (_context22.p = _context22.n) {
          case 0:
            commit = _ref38.commit;
            type = _ref39.type, days = _ref39.days;
            _context22.p = 1;
            _context22.n = 2;
            return _dashboard.default.fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType(type, days);
          case 2:
            _yield$DashboardServi22 = _context22.v;
            data = _yield$DashboardServi22.data;
            return _context22.a(2, data);
          case 3:
            _context22.p = 3;
            _t22 = _context22.v;
            _helpers.errorResponseHelper.display(_t22);
            return _context22.a(2, false);
        }
      }, _callee22, null, [[1, 3]]);
    }));
    function fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType(_x45, _x46) {
      return _fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType.apply(this, arguments);
    }
    return fetchConsolidatedQuantitiesOfProtocolsInLastDaysByType;
  }(),
  fetchConsolidatedGetsInLastDays: function () {
    var _fetchConsolidatedGetsInLastDays = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(_ref40, _ref41) {
      var commit, days, _yield$DashboardServi23, data, _t23;
      return _regenerator().w(function (_context23) {
        while (1) switch (_context23.p = _context23.n) {
          case 0:
            commit = _ref40.commit;
            days = _ref41.days;
            _context23.p = 1;
            _context23.n = 2;
            return _dashboard.default.fetchConsolidatedGetsInLastDays(days);
          case 2:
            _yield$DashboardServi23 = _context23.v;
            data = _yield$DashboardServi23.data;
            return _context23.a(2, data);
          case 3:
            _context23.p = 3;
            _t23 = _context23.v;
            _helpers.errorResponseHelper.display(_t23);
            return _context23.a(2, false);
        }
      }, _callee23, null, [[1, 3]]);
    }));
    function fetchConsolidatedGetsInLastDays(_x47, _x48) {
      return _fetchConsolidatedGetsInLastDays.apply(this, arguments);
    }
    return fetchConsolidatedGetsInLastDays;
  }(),
  fetchProtocolsDetailsByPhaseGroupByTypeInLastDays: function () {
    var _fetchProtocolsDetailsByPhaseGroupByTypeInLastDays = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(_ref42, _ref43) {
      var commit, phase, group, days, _yield$DashboardServi24, data, _t24;
      return _regenerator().w(function (_context24) {
        while (1) switch (_context24.p = _context24.n) {
          case 0:
            commit = _ref42.commit;
            phase = _ref43.phase, group = _ref43.group, days = _ref43.days;
            _context24.p = 1;
            _context24.n = 2;
            return _dashboard.default.fetchProtocolsDetailsByPhaseGroupByTypeInLastDays(phase, group, days);
          case 2:
            _yield$DashboardServi24 = _context24.v;
            data = _yield$DashboardServi24.data;
            return _context24.a(2, data);
          case 3:
            _context24.p = 3;
            _t24 = _context24.v;
            _helpers.errorResponseHelper.display(_t24);
            return _context24.a(2, false);
        }
      }, _callee24, null, [[1, 3]]);
    }));
    function fetchProtocolsDetailsByPhaseGroupByTypeInLastDays(_x49, _x50) {
      return _fetchProtocolsDetailsByPhaseGroupByTypeInLastDays.apply(this, arguments);
    }
    return fetchProtocolsDetailsByPhaseGroupByTypeInLastDays;
  }(),
  consultProtocolComplete: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref45 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(_ref44, payload) {
      var commit, _yield$DashboardServi25, data, _t25;
      return _regenerator().w(function (_context25) {
        while (1) switch (_context25.p = _context25.n) {
          case 0:
            commit = _ref44.commit;
            _context25.p = 1;
            _context25.n = 2;
            return _dashboard.default.consultProtocolComplete(payload);
          case 2:
            _yield$DashboardServi25 = _context25.v;
            data = _yield$DashboardServi25.data;
            return _context25.a(2, data);
          case 3:
            _context25.p = 3;
            _t25 = _context25.v;
            _helpers.errorResponseHelper.display(_t25);
            return _context25.a(2, false);
        }
      }, _callee25, null, [[1, 3]]);
    }));
    return function (_x51, _x52) {
      return _ref45.apply(this, arguments);
    };
  }()),
  fetchChartIPs: function () {
    var _fetchChartIPs = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(_ref46, _ref47) {
      var commit, params, _yield$DashboardServi26, data, _t26;
      return _regenerator().w(function (_context26) {
        while (1) switch (_context26.p = _context26.n) {
          case 0:
            commit = _ref46.commit;
            params = _ref47.params;
            _context26.p = 1;
            _context26.n = 2;
            return _dashboard.default.fetchChartIPs(params);
          case 2:
            _yield$DashboardServi26 = _context26.v;
            data = _yield$DashboardServi26.data;
            return _context26.a(2, data);
          case 3:
            _context26.p = 3;
            _t26 = _context26.v;
            _helpers.errorResponseHelper.display(_t26);
            return _context26.a(2, false);
        }
      }, _callee26, null, [[1, 3]]);
    }));
    function fetchChartIPs(_x53, _x54) {
      return _fetchChartIPs.apply(this, arguments);
    }
    return fetchChartIPs;
  }(),
  fetchChartPaths: function () {
    var _fetchChartPaths = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(_ref48, _ref49) {
      var commit, params, _yield$DashboardServi27, data, _t27;
      return _regenerator().w(function (_context27) {
        while (1) switch (_context27.p = _context27.n) {
          case 0:
            commit = _ref48.commit;
            params = _ref49.params;
            _context27.p = 1;
            _context27.n = 2;
            return _dashboard.default.fetchChartPaths(params);
          case 2:
            _yield$DashboardServi27 = _context27.v;
            data = _yield$DashboardServi27.data;
            return _context27.a(2, data);
          case 3:
            _context27.p = 3;
            _t27 = _context27.v;
            _helpers.errorResponseHelper.display(_t27);
            return _context27.a(2, false);
        }
      }, _callee27, null, [[1, 3]]);
    }));
    function fetchChartPaths(_x55, _x56) {
      return _fetchChartPaths.apply(this, arguments);
    }
    return fetchChartPaths;
  }(),
  fetchChartErrors: function () {
    var _fetchChartErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28(_ref50, _ref51) {
      var commit, params, _yield$DashboardServi28, data, _t28;
      return _regenerator().w(function (_context28) {
        while (1) switch (_context28.p = _context28.n) {
          case 0:
            commit = _ref50.commit;
            params = _ref51.params;
            _context28.p = 1;
            _context28.n = 2;
            return _dashboard.default.fetchChartErrors(params);
          case 2:
            _yield$DashboardServi28 = _context28.v;
            data = _yield$DashboardServi28.data;
            return _context28.a(2, data);
          case 3:
            _context28.p = 3;
            _t28 = _context28.v;
            _helpers.errorResponseHelper.display(_t28);
            return _context28.a(2, false);
        }
      }, _callee28, null, [[1, 3]]);
    }));
    function fetchChartErrors(_x57, _x58) {
      return _fetchChartErrors.apply(this, arguments);
    }
    return fetchChartErrors;
  }(),
  fetchErrors: function () {
    var _fetchErrors = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(_ref52, _ref53) {
      var commit, params, _yield$DashboardServi29, data, _t29;
      return _regenerator().w(function (_context29) {
        while (1) switch (_context29.p = _context29.n) {
          case 0:
            commit = _ref52.commit;
            params = _ref53.params;
            _context29.p = 1;
            _context29.n = 2;
            return _dashboard.default.fetchErrors(params);
          case 2:
            _yield$DashboardServi29 = _context29.v;
            data = _yield$DashboardServi29.data;
            return _context29.a(2, data);
          case 3:
            _context29.p = 3;
            _t29 = _context29.v;
            _helpers.errorResponseHelper.display(_t29);
            return _context29.a(2, false);
        }
      }, _callee29, null, [[1, 3]]);
    }));
    function fetchErrors(_x59, _x60) {
      return _fetchErrors.apply(this, arguments);
    }
    return fetchErrors;
  }(),
  fetchtListAllBUUsernames: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref55 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee30(_ref54) {
      var commit, _yield$DashboardServi30, data, _t30;
      return _regenerator().w(function (_context30) {
        while (1) switch (_context30.p = _context30.n) {
          case 0:
            commit = _ref54.commit;
            _context30.p = 1;
            _context30.n = 2;
            return _dashboard.default.fetchtListAllBUUsernames();
          case 2:
            _yield$DashboardServi30 = _context30.v;
            data = _yield$DashboardServi30.data;
            return _context30.a(2, data);
          case 3:
            _context30.p = 3;
            _t30 = _context30.v;
            _helpers.errorResponseHelper.display(_t30);
            return _context30.a(2, false);
        }
      }, _callee30, null, [[1, 3]]);
    }));
    return function (_x61) {
      return _ref55.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};